import React, { useState } from 'react';
import { toast } from 'sonner';
import { Bell, Mail, MessageSquare, Send, CheckCircle } from 'lucide-react';

import { authHeaders } from '../lib/authToken';
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function AdminNotifications() {
  const [orderId, setOrderId] = useState('');
  const [quoteId, setQuoteId] = useState('');
  const [reminderType, setReminderType] = useState('j2');
  const [loading, setLoading] = useState({});
  const [brevoStatus, setBrevoStatus] = useState(null);

  useState(() => {
    fetch(`${BACKEND}/api/notifications/status`, { headers: authHeaders() })
      .then(r => r.json())
      .then(d => setBrevoStatus(d))
      .catch((err) => { /* eslint-disable-line no-empty */ });
  }, []);

  async function sendRappel() {
    if (!orderId) { toast.error('ID commande requis'); return; }
    setLoading(l => ({ ...l, rappel: true }));
    const res = await fetch(`${BACKEND}/api/notifications/rappel/${orderId}`, {
      method: 'POST',
      headers: authHeaders({ 'Content-Type': 'application/json' }),
      body: JSON.stringify({ type: reminderType })
    });
    const data = await res.json();
    toast.success(`Rappel ${reminderType} envoyé (${data.results?.email?.simulated ? 'simulé' : 'réel'})`);
    setLoading(l => ({ ...l, rappel: false }));
  }

  async function sendDevisEmail() {
    if (!quoteId) { toast.error('ID devis requis'); return; }
    setLoading(l => ({ ...l, devis: true }));
    const res = await fetch(`${BACKEND}/api/notifications/email/devis/${quoteId}`, { method: 'POST', headers: authHeaders() });
    const data = await res.json();
    toast.success(`Email devis envoyé (${data.simulated ? 'simulé' : 'réel'})`);
    setLoading(l => ({ ...l, devis: false }));
  }

  return (
    <div className="max-w-2xl space-y-5">
      <div>
        <h2 className="font-display text-xl font-bold" style={{ color: 'var(--admin-text)' }}>Notifications</h2>
        <p className="text-xs" style={{ color: 'var(--admin-muted)' }}>Emails et SMS via Brevo (simulation active tant que BREVO_API_KEY n’est pas défini)</p>
      </div>

      {/* Status */}
      {brevoStatus && (
        <div className="px-4 py-3 rounded-xl flex items-center gap-3" style={{
          background: brevoStatus.brevo_enabled ? 'rgba(61,220,151,0.08)' : 'rgba(255,204,102,0.08)',
          border: `1px solid ${brevoStatus.brevo_enabled ? '#3DDC97' : '#FFCC66'}30`
        }}>
          {brevoStatus.brevo_enabled ? <CheckCircle size={16} style={{ color: '#3DDC97' }} /> : <Bell size={16} style={{ color: '#FFCC66' }} />}
          <span className="text-xs" style={{ color: brevoStatus.brevo_enabled ? '#3DDC97' : '#FFCC66' }}>
            {brevoStatus.note}
          </span>
        </div>
      )}

      {/* Rappels J-2 / J-1 / Jour J */}
      <div className="p-5 rounded-xl" style={{ background: 'var(--admin-surface)', border: '1px solid #2A2A2A' }}>
        <div className="flex items-center gap-2 mb-4">
          <Bell size={16} style={{ color: 'var(--admin-gold)' }} />
          <h3 className="font-semibold text-sm" style={{ color: 'var(--admin-text)' }}>Rappels automatiques</h3>
        </div>
        <div className="grid sm:grid-cols-3 gap-2 mb-4">
          {[{id:'j2',label:'J-2'},{id:'j1',label:'J-1'},{id:'jour_j',label:'Jour J'}].map(r => (
            <button key={r.id} onClick={() => setReminderType(r.id)}
              className="py-2 rounded-xl text-sm font-semibold"
              style={{ background: reminderType === r.id ? 'rgba(212,175,55,0.15)' : '#1C1C1C', border: reminderType === r.id ? '1px solid #D4AF37' : '1px solid #2A2A2A', color: reminderType === r.id ? '#D4AF37' : 'rgba(255,255,255,0.5)' }}>
              {r.label}
            </button>
          ))}
        </div>
        <div className="flex gap-3">
          <input type="text" value={orderId} onChange={e => setOrderId(e.target.value)}
            placeholder="ID de la commande"
            className="flex-1 px-3 py-2.5 rounded-xl text-sm" style={{ background: '#1C1C1C', border: '1px solid #2A2A2A', color: 'var(--admin-text)' }} />
          <button onClick={sendRappel} disabled={loading.rappel}
            className="btn-gold px-4 py-2.5 rounded-xl text-sm font-semibold flex items-center gap-2 disabled:opacity-40">
            <Send size={14} /> Envoyer
          </button>
        </div>
      </div>

      {/* Email devis */}
      <div className="p-5 rounded-xl" style={{ background: 'var(--admin-surface)', border: '1px solid #2A2A2A' }}>
        <div className="flex items-center gap-2 mb-4">
          <Mail size={16} style={{ color: '#C5D8F9' }} />
          <h3 className="font-semibold text-sm" style={{ color: 'var(--admin-text)' }}>Email confirmation devis</h3>
        </div>
        <div className="flex gap-3">
          <input type="text" value={quoteId} onChange={e => setQuoteId(e.target.value)}
            placeholder="ID du devis"
            className="flex-1 px-3 py-2.5 rounded-xl text-sm" style={{ background: '#1C1C1C', border: '1px solid #2A2A2A', color: 'var(--admin-text)' }} />
          <button onClick={sendDevisEmail} disabled={loading.devis}
            className="px-4 py-2.5 rounded-xl text-sm font-semibold flex items-center gap-2 disabled:opacity-40"
            style={{ background: 'rgba(197,216,249,0.12)', color: '#C5D8F9', border: '1px solid rgba(197,216,249,0.2)' }}>
            <Send size={14} /> Envoyer
          </button>
        </div>
      </div>
    </div>
  );
}
